(() => {
  if(customElements.get('mxw-pcb-motion')) return;
  customElements.define('mxw-pcb-motion', class extends HTMLElement {
    connectedCallback() {
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPause = false;
      this.visible = false;
      this.button = this.querySelector('button');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.refresh = () => {
        const reduced = this.motion.matches;
        this.classList.toggle('is-playing', this.visible && !document.hidden && !this.manualPause && !reduced);
        this.button.hidden = reduced;
        this.button.textContent = this.manualPause ? 'Play animation' : 'Pause animation';
        this.button.setAttribute('aria-label', this.manualPause ? 'Play board animation' : 'Pause board animation');
        this.button.setAttribute('aria-pressed', String(this.manualPause));
      };
      this.button.addEventListener('click', () => {this.manualPause = !this.manualPause; this.refresh();}, {signal});
      this.motion.addEventListener('change', this.refresh, {signal});
      document.addEventListener('visibilitychange', this.refresh, {signal});
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(e => e.isIntersecting);
        this.refresh();
      }, {threshold:.1});
      this.observer.observe(this);
      this.refresh();
    }
    disconnectedCallback() {this.observer?.disconnect(); this.controller?.abort();}
  });
})();
